import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { fetchPaymentMethods } from "./paymentMethods.thunk";

const paymentMethodsSlice = createSlice({
  name: "paymentMethods",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload;
      })
      .addCase(fetchPaymentMethods.rejected, (state, { meta }) => {
        state.isLoading = false;
        state.error = meta.aborted ? null : "Failed to fetch payment methods";
      });
  },
});

export default paymentMethodsSlice.reducer;
